const VEHICLEPASS_LIST_ACTIONS = {
  VEHICLEPASS_LIST: {
    PENDING: 'VEHICLEPASS_LIST_PENDING',
    SUCCESS: 'VEHICLEPASS_LIST_SUCCESS',
    FAILURE: 'VEHICLEPASS_LIST_FAILURE',
  },
  LIST_PENDING: {
    PENDING: 'VEHICLEPASS_LIST_PENDING_PENDING',
    SUCCESS: 'VEHICLEPASS_LIST_PENDING_SUCCESS',
    FAILURE: 'VEHICLEPASS_LIST_PENDING_FAILURE',
  },
}

export const VEHICLEPASS_LIST_STATE = {
  REFRESHED: 'VEHICLEPASS_LIST_REFRESHED',
  IN_PROGRESS: 'VEHICLEPASS_LIST_IN_PROGRESS',
  SUCCESS: 'VEHICLEPASS_LIST_RETRIEVED',
  ERROR: 'VEHICLEPASS_LIST_ERROR',
  PENDING: 'VEHICLEPASS_LIST_PENDING',
}

export const VEHICLEPASS_LIST_PENDING_STATE = {
  REFRESHED: 'VEHICLEPASS_LIST_PENDING_REFRESHED',
  IN_PROGRESS: 'VEHICLEPASS_LIST_PENDING_IN_PROGRESS',
  SUCCESS: 'VEHICLEPASS_LIST_PENDING_RETRIEVED',
  ERROR: 'VEHICLEPASS_LIST_PENDING_ERROR',
  PENDING: 'VEHICLEPASS_LIST_PENDING_PENDING',
}

export default VEHICLEPASS_LIST_ACTIONS
